export const setList = (state, payload) => state.list = payload;
export const setListExceptId = (state, payload) => state.listExceptId = payload;
export const removeItem = (state, payload) => state.listExceptId.splice(payload, 1);
